export enum EReqHeaders {
  AUTHORIZATION = "Authorization",
  LANGUAGE = "X-Language",
}
